"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.claimAccessSchema = void 0;
var constants_1 = require("@hobt/constants");
var access_schema_1 = require("./access-schema");
exports.claimAccessSchema = __assign(__assign({}, access_schema_1.accessSchema), { properties: __assign(__assign({}, access_schema_1.accessSchema.properties), { inventoryViewTypeCode: {
            type: ['number', 'null'],
            enum: __spreadArrays(Object.values(constants_1.ClaimInventoryViewType), [null]),
            errorMessage: 'Should equate to a valid ClaimInventoryViewType Enum value or null',
        }, probationaryUserFlag: {
            type: ['boolean', 'null'],
            errorMessage: 'Should be a boolean or null',
        } }) });
